<template>
    <div id="app">
    <vue-loading-component />
        <router-view name="header"></router-view>
        <main>
          <fade-transition origin="center" mode="out-in" :duration="250">
            <router-view/>
          </fade-transition>
        </main>
        <router-view name="footer"></router-view>
        <modal id="app-modal" :show.sync="showStateModal"
            :modal-classes="stateModal.classe">
            <div class="py-3 text-center">
                <i :class="stateModal.icon"></i>
                <h4 class="heading mt-4">{{stateModal.title}}</h4>
                <p>{{stateModal.body}}</p>
                <div v-if="!stateModal.closeBtnLabel">
                  <base-button :type="stateModal.okType" class="ml-auto" :outline="stateModal.okOutline" @click="stateModalAction()" v-if="stateModal.okAction">{{stateModal.okButton}}</base-button>
                  <base-button :type="stateModal.okType" class="ml-auto" :outline="stateModal.okOutline" @click="toggleStateModal" v-else>{{stateModal.okButton}}</base-button>
                </div>
            </div>
            <template slot="footer" v-if="stateModal.closeBtnLabel">
              <base-button :type="stateModal.okType" :outline="stateModal.okOutline" @click="stateModalAction()" v-if="stateModal.okAction">{{stateModal.okButton}}</base-button>
              <base-button :type="stateModal.okType" :outline="stateModal.okOutline" @click="toggleStateModal" v-else>{{stateModal.okButton}}</base-button>
              <base-button :type="stateModal.closeBtnType" class="ml-auto" @click="toggleStateModal">{{stateModal.closeBtnLabel}}</base-button>
            </template>
        </modal>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import { mapGetters, mapActions } from 'vuex';

import Modal from "@/components/Modal.vue";

export default {
  name: 'app',
  components: {
    FadeTransition, Modal
  },
  data() {
    return {
      modal: {
        title: '',
        body: '', 
        classe: 'modal-danger',
        icon: 'fa fa-times-circle',
        okButton: 'OK',
        closeBtnLabel: null,
        okAction: null,
        okType: 'success',
      },
    };
  },
  computed: {
    ...mapGetters('auth', [
      'isAuthenticated',
    ]),
    ...mapGetters('modal', [
      'showModal',
      'showStateModal',
      'stateModal',
    ]),
    ...mapGetters('catalog', [
      'isSyncronized',
    ]),
  },
  methods: {
    ...mapActions('modal', ['toggleStateModal']),
    stateModalAction() {
      if ( this.stateModal.okAction ) {
        this.$router.push(this.stateModal.okAction)
      }
      this.$store.dispatch('modal/toggleStateModal')
    },
    async loadFilters() {
      if ( !this.isSyncronized ) {
        this.axios.get('/v1/titulos/filtros')
        .then(response => {
          this.$store.dispatch('catalog/setCatalogFilterData', response )
        });
      }
    },
  },
  mounted: function () {
    this.$nextTick(function () {
      this.loadFilters();
    })
  }
};
</script>
<style lang="scss">
    .gold {
      background: #fffce6 !important;
    }
    .recaptcha-block {
        > div {
            margin: 0 auto;
        }
    }
    .modal {
      .fa, .ni {
        font-size: 5em;
      }
      span.input-group-text {
        .fa, .ni {
          font-size: initial;
        }
      }
    }
    .v-select.input-group-alternative {
      background: #fff;
      padding: 0.325rem 0.275rem;
      font-size: 0.875rem;
      &.error {
        border: 1px solid #fb6340;
      } 
    }

    .form-group.input-group-alternative.has-danger {
      border: 1px solid #fb6340;
    }
</style>
